module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fast-links"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('titulo', {
    staticClass: "-upper -withbar"
  }, [_vm._v("Links Importantes")]), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "http://idg.receita.fazenda.gov.br/",
      "target": "_blank"
    }
  }, [_vm._v("Receita")])]), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.crcrn.org.br/",
      "target": "_blank"
    }
  }, [_vm._v("CRC/RN")])]), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.natal.rn.gov.br/",
      "target": "_blank"
    }
  }, [_vm._v("Prefeitura de Natal")])]), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.natal.rn.gov.br/semut/",
      "target": "_blank"
    }
  }, [_vm._v("SEMUT")])]), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.rn.gov.br/",
      "target": "_blank"
    }
  }, [_vm._v("Governo do RN")])]), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "http://www.set.rn.gov.br/",
      "target": "_blank"
    }
  }, [_vm._v("Secretaria de Tributação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bff06f02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/LinksImportantes.vue
// module id = 511
// module chunks = 0